module.exports = __webpack_public_path__ + "img/HHaplakat2025.0ae4b5e7.jpg";